import React from 'react';
import './Portfolio.scss';
import PortfolioItem from './portfolioItem';
import { portfolioProjects } from 'src/data/portfolio';

const Portfolio: React.FC = () => {
  return (
    <>
      <div className="header align-center pt-5 mt-5">
        <h1 className="block-center">Full-Stack Development Portfolio</h1>
        <p className="subtitle block-center">
          Here are some of the projects I've worked on. Click to learn more about each project.
        </p>
      </div>

      {portfolioProjects.map((item) => (
        <PortfolioItem
          key={item.id}
          id={item.id}
          projectName={item.projectName}
          projectDescription={item.projectDescription}
          screenshotUrl={item.screenshotUrl}
          logoUrl={item.logoUrl}
        />
      ))}
    </>
  );
};

export default Portfolio;
